class Utils {
    static mobile(){
        return window.innerWidth < 768 ? true : false;
    }
}

export default Utils;